import React from 'react';
import Link from 'next/link';
import { useActionPlanContext } from '../../hooks/ActionPlanContext'; // Assuming the context is in 'hooks' folder

const PolicyAreaList: React.FC = () => {
    const { data, loading, error } = useActionPlanContext();

    if (loading) {
        return <div></div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!data) {
        return <div>No data available</div>;
    }

    const policyAreas = data.actionPlanData.policy_areas;

    return (
        <div className="list-of-areas">
            <div className="full-wrap-category-holder">
                <div className="area-holder">
                    <div className="policy-area-collection w-dyn-list">
                        <div role="list" className="filtering-list w-dyn-items">
                            {policyAreas.map((area) => (
                                <div key={area.area_no} role="listitem" className="collection-item w-dyn-item">
                                    <Link href={`#0${area.area_no}`} className="mini-filtering-card w-inline-block">
                                        <img
                                            src={area.imgSrc}
                                            loading="lazy"
                                            alt={area.policy_area}
                                            sizes="(max-width: 479px) 120px, (max-width: 991px) 107.5625px, 11vw"
                                            srcSet={`${area.imgSrc.replace(".png", "")}-p-500.png 500w, ${area.imgSrc.replace(".png", "")}-p-800.png 800w, ${area.imgSrc.replace(".png", "")} 1024w`}
                                            className="mini-card-visual"
                                        />
                                        <div className="filtering-number-display">{`0${area.area_no}`}</div>
                                        <div className="filtering-heading-set">
                                            <h2 className="filtering-title">{area.policy_area}</h2>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PolicyAreaList;
